<template>
  <b-alert
    id="alertBar"
    :show="alertCountdown"
    dismissible
    :variant="alertType"
    @dismissed="$store.commit('app/resetAlert')"
    @dismiss-count-down="countDownChanged"
  >{{alertMessage}}</b-alert>
</template>
<style lang="scss" scoped>
#alertBar {
  position: fixed;
  width: 100%;
  z-index: 9999;
  opacity: 0.9;
}
</style>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['alertType', 'alertMessage', 'alertCountdown'])
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.$store.commit('app/setAlertCountdown', dismissCountDown)
    }
  } //end methods
}; //end export
</script>